// LogViewerReducer.ts
import { type ProcessedChunk, type ProgressResult } from './LogProcessor';

export type LogViewerState = {
  progress?: ProgressResult;
  rawChunks: ProcessedChunk[];
  lineWrapping: boolean;
  toolbarDisabled: boolean;
  errorMarkerIndex: number;
};

export type LogViewerAction =
  | { type: 'INITIALIZE_PROCESSING' }
  | { type: 'CHANGE_LINE_WRAPPING'; payload: boolean }
  | { type: 'PROCESS_RAW_CHUNK'; payload: ProcessedChunk }
  | { type: 'UPDATE_PROGRESS'; payload: ProgressResult }
  | { type: 'COMPLETE_PROCESSING' }
  | { type: 'SET_CURRENT_ERROR_MARKER'; payload: number };
export const INITIAL_STATE: LogViewerState = {
  progress: undefined,
  rawChunks: [],
  lineWrapping: false,
  toolbarDisabled: true,
  errorMarkerIndex: -1,
};

export function logViewerReducer(state: LogViewerState, action: LogViewerAction): LogViewerState {
  switch (action.type) {
    case 'INITIALIZE_PROCESSING':
      return INITIAL_STATE;
    case 'CHANGE_LINE_WRAPPING':
      return {
        ...state,
        lineWrapping: action.payload,
      };

    case 'PROCESS_RAW_CHUNK': {
      const newRawChunks = [...state.rawChunks];
      newRawChunks[action.payload.index] = action.payload;

      return {
        ...state,
        rawChunks: newRawChunks,
      };
    }

    case 'UPDATE_PROGRESS':
      return {
        ...state,
        progress: action.payload,
      };

    case 'COMPLETE_PROCESSING':
      return {
        ...state,
        progress: undefined,
        toolbarDisabled: false,
      };

    case 'SET_CURRENT_ERROR_MARKER':
      return {
        ...state,
        errorMarkerIndex: action.payload,
      };

    default:
      return state;
  }
}
